var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"subscriber":_vm.subscriber,"title":_vm.$tc('phrases.agentTicket',1),"paginator":_vm.agentTicketService.paginator,"color":"green"}},[_c('ticket-item',{attrs:{"allow-comment":true,"allow-lock":false,"table-heads":_vm.tableHeads,"ticket-list":_vm.agentTicketService.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }